export default __webpack_public_path__ + "static/media/content_05_bg.551d40c7.jpg";